import React from 'react'

import styled from 'styled-components'
import MenuItem from '@/components/MenuItem'
import {ROUTES} from '@/utils/routes'
import {useSelector} from 'react-redux'
import {InitialStateType} from '@/store/reducers'

const MenuWrapper = styled.div`
  display: flex;
  height: 100%;
`

export default function Menu() {

    const {type} = useSelector((state: InitialStateType) => state.user)
    
    return (
        <MenuWrapper>
            <MenuItem to={ROUTES.HOME} title='Home' />
            <MenuItem to={ROUTES.DATA_INFO} title='Data info' />
            {type === 'user' && <MenuItem to={ROUTES.JOBS_DATASET} title='Jobs' />}
        </MenuWrapper>
    )
}
